import { Icon } from "./Icon.tsx";

/** MapSettingsMenu.tsx's own trigger icon — a folded paper map, distinct from SettingsMenu.tsx's own gear (app-wide theme/language) and OptionsIcon's sliders (simulation options): this one groups things that change what the MAP ITSELF shows (overview, flow direction...). */
export function MapSettingsIcon() {
  return (
    <Icon>
      <path d="M9 4 4 6v14l5-2 6 2 5-2V4l-5 2-6-2Z" />
      <path d="M9 4v14M15 6v14" />
    </Icon>
  );
}
